import { post } from './http';

export const add = async ({ articleNumber, quantity = 1 }) => {
    if (!quantity || isNaN(quantity) || parseFloat(quantity) <= 0) {
        throw 'Invalid quantity';
    }

    // Retrieve the list of selected products from session storage
    const selectedProducts = JSON.parse(sessionStorage.getItem('selectedProducts')) || [];

    // Prepare the payload for the API request
    const payload = {
        articleNumber,
        quantity: parseFloat(quantity),
        selectedProducts: selectedProducts.map(product => ({
            articleNumber: product.artNr,
            name: product.name,
            price: product.price,
            quantity: product.quantity
        }))
    };

    // Send the request to the API
    const response = await post('/api/cart/add', payload);
    return response.json();
};

export const reorder = async (orderId) => {
    const response = await post('/api/cart/reorder', { orderId });
    return response.json();
};
